
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import CustomPopOver from '../../CustomPopOver/CustomPopOver';
import CustomButton from '../../CustomButton/CustomButton';
import style from '../CustomViewTask.module.css';

interface SalesforceAuthPopoverProps {
  anchorEl: HTMLDivElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  action: string;
  selectedData: any;
  onClose: () => void;
}

export const SalesforceAuthPopover: React.FC<SalesforceAuthPopoverProps> = ({
  anchorEl,
  setAnchorEl,
  action,
  selectedData,
  onClose,
}) => {
  const location = useLocation();
  const openTask = Boolean(anchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;

  const handleOpenSalesforce = () => {
    onClose();
    sessionStorage.setItem('sf_redirect', 'Task');
    sessionStorage.setItem('sf_edit_selected', JSON.stringify(selectedData));
    sessionStorage.setItem('sf_task_status', selectedData?.status);
    sessionStorage.setItem('redirect_path', location?.pathname);
    if (action === 'edit') {
      sessionStorage.setItem('sf_edit', 'true');
    } else if (action === 'markAsDone') {
      sessionStorage.setItem('sf_marked', 'true');
    } else {
      sessionStorage.setItem('sf_delete', 'true');
    }
  };

  return (
    <CustomPopOver
      setAnchorEl={setAnchorEl}
      anchorEl={anchorEl}
      id={idTask}
      sx={{
        borderRadius: '14px',
        boxShadow: 'rgba(0, 0, 0, 0.15)',
        marginTop: '8px',
      }}
    >
      <Box
        sx={{
          height: '202px',
          width: '340px',
          padding: '24px',
          display: 'flex',
          gap: '32px',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
          <Box
            sx={{
              display: 'flex',
              gap: { xs: '6px', xl: '12px' },
              justifyContent: 'space-between',
            }}
          >
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              Authentication Required
            </Typography>
            <img
              src={'/assets/close-icon.svg'}
              className={style['icon']}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setAnchorEl(null);
              }}
            />
          </Box>

          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
            You need to be logged into Salesforce to perform this action. Please log in to your
            Salesforce account.
          </Typography>
        </Box>
        <Link
          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
        >
          <CustomButton
            disabled={false}
            onClick={handleOpenSalesforce}
            variant='contained'
            color={'primary'}
            style={{
              width: '155px',
              borderRadius: '14px',
              height: '48px',
              padding: '14px 16px',
              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            text={'Open Salesforce'}
          />
        </Link>
      </Box>
    </CustomPopOver>
  );
};
